import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "layout"
};
const _hoisted_2 = {
  class: "layout-header"
};
const _hoisted_3 = {
  class: "layout-body"
};
const _hoisted_4 = {
  class: "layout-sidebar"
};
const _hoisted_5 = {
  class: "layout-main"
};
const _hoisted_6 = {
  class: "layout-breadcrumb"
};
const _hoisted_7 = {
  class: "layout-content"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_navBar = _resolveComponent("navBar");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_menu_item = _resolveComponent("el-menu-item");
  const _component_el_menu_item_group = _resolveComponent("el-menu-item-group");
  const _component_el_sub_menu = _resolveComponent("el-sub-menu");
  const _component_el_menu = _resolveComponent("el-menu");
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb");
  const _component_router_view = _resolveComponent("router-view");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("header", _hoisted_2, [_createVNode(_component_navBar, {
    navBarActiveUrl: _ctx.navBarActiveUrl,
    "onUpdate:navBarActiveUrl": _cache[0] || (_cache[0] = $event => _ctx.navBarActiveUrl = $event),
    "nav-bar-list": _ctx.navBarList,
    onClickNavBar: _ctx.handleNavBar
  }, null, 8, ["navBarActiveUrl", "nav-bar-list", "onClickNavBar"])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("aside", _hoisted_4, [_createVNode(_component_el_menu, {
    "default-active": _ctx.sideBarActiveUrl,
    router: true,
    class: "sidebar-menu"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.siderBarList, (item, index) => {
      return _openBlock(), _createElementBlock(_Fragment, {
        key: item.id
      }, [item.children && item.children.length > 0 && item.meta.twoCategroy !== 'none' ? (_openBlock(), _createBlock(_component_el_sub_menu, {
        key: 0,
        index: item.path,
        class: "sidebar-submenu"
      }, {
        title: _withCtx(() => [_createVNode(_component_el_icon, {
          class: "menu-icon"
        }, {
          default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(item.meta.icon)))]),
          _: 2
        }, 1024), _createElementVNode("span", null, _toDisplayString(item.meta.title), 1)]),
        default: _withCtx(() => [_createVNode(_component_el_menu_item_group, {
          class: "sidebar-submenu-group"
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, twoItem => {
            return _openBlock(), _createElementBlock(_Fragment, {
              key: twoItem.path
            }, [twoItem.meta?.display !== 'none' ? (_openBlock(), _createBlock(_component_el_menu_item, {
              key: 0,
              index: twoItem.path,
              class: "sidebar-submenu-item"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(twoItem.meta.title), 1)]),
              _: 2
            }, 1032, ["index"])) : _createCommentVNode("", true)], 64);
          }), 128))]),
          _: 2
        }, 1024)]),
        _: 2
      }, 1032, ["index"])) : item.meta.display !== 'none' ? (_openBlock(), _createBlock(_component_el_menu_item, {
        key: 1,
        index: item.path,
        onClick: $event => _ctx.clickSiderBar(index, item),
        class: "sidebar-item"
      }, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(item.meta.title), 1)]),
        default: _withCtx(() => [_createVNode(_component_el_icon, {
          class: "menu-icon"
        }, {
          default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(item.meta.icon)))]),
          _: 2
        }, 1024)]),
        _: 2
      }, 1032, ["index", "onClick"])) : _createCommentVNode("", true)], 64);
    }), 128))]),
    _: 1
  }, 8, ["default-active"])]), _createElementVNode("main", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_breadcrumb, null, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.breadcrumbList, (item, index) => {
      return _openBlock(), _createBlock(_component_el_breadcrumb_item, {
        key: index,
        to: {
          path: item.path
        }
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(item.meta.title), 1)]),
        _: 2
      }, 1032, ["to"]);
    }), 128))]),
    _: 1
  })]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_router_view)])])])]);
}